import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {LoginService} from './login/login.service';
import {LoginComponent} from './login/login.component';
import {LogoutComponent} from './login/logout.component';
import {MaterialModule} from './material.module';
import {PageNotFoundComponent} from './components/page-not-found.component';
import {ForbiddenComponent} from './components/forbidden.component';
import {SnackBarService} from './services/snackbar.service';
import {GlobalSpinnerService} from './services/global-spinner.service';
import {GlobalSpinnerComponent} from './services/global-spinner.component';
import {HttpClientModule} from '@angular/common/http';
import {AuthGuard} from './guards/auth-guard.service';
import {CommonModule} from '@angular/common';
import {AdminGuard} from './guards/admin-guard.service';
import {PublisherGuard} from './guards/publisher-guard.service';
import {UserResolver} from './resolvers/user.resolver';
import {PublisherResolver} from './resolvers/publisher.resolver';
import {AppRoleGuard} from './guards/app-role-guard.service';
import {NetworkGuard} from './guards/network-guard.service';
import {ContentOwnerGuard} from './guards/content-owner-guard.service';
import { TwoDigitDecimaNumberDirective } from '../shared/directive/two-digit-decimal-number.directive';
import { HasNetworkPermissionDirective } from '../shared/directive/has-network-permission.directive';
import { NetworkGuardPublisher } from './guards/network-guard-publisher.service';
import { FourDigitDecimaNumberDirective } from '../shared/directive/four-digit-decimal-number.directive';
import { CommifiedNumberInputDirective } from '../shared/directive/commified-number-input.directive';
import { HasSalesRepPermissionDirective } from '../shared/directive/has-sales-rep-permission.directive';
import { HasPermissionDirective } from './auth/rbac/has-permission.directive';
import { RolePermissionService } from './auth/rbac/role-permission.service';
import { HasNoPermissionDirective } from './auth/rbac/has-no-permission.directive';
import { HasUserRolePermissionDirective } from '../shared/directive/has-user-role-permission.directive';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { NewPasswordComponent } from './new-password/new-password.component';
import { TargetingHideForDirective } from '../modules/targeting/targeting-create-edit/targeting-form/targeting-hide-for.directive';
import { DoubleClickToEnableDirective } from '../shared/directive/dbclick-input.directive';
import { ScrollToSectionDirective } from '../shared/directive/scroll-to-section.directive';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        HttpClientModule,
    ],
    declarations: [
        LoginComponent,
        ForgotPasswordComponent,
        NewPasswordComponent,
        LogoutComponent,
        PageNotFoundComponent,
        ForbiddenComponent,
        GlobalSpinnerComponent,
        TwoDigitDecimaNumberDirective,
        FourDigitDecimaNumberDirective,
        HasNetworkPermissionDirective,
        CommifiedNumberInputDirective,
        HasSalesRepPermissionDirective,
        HasUserRolePermissionDirective,
        HasPermissionDirective,
        TargetingHideForDirective,
        HasNoPermissionDirective,
        HasNoPermissionDirective,
        DoubleClickToEnableDirective,
        ScrollToSectionDirective
    ],
    providers: [
        LoginService,
        SnackBarService,
        AuthGuard,
        AppRoleGuard,
        NetworkGuard,
        NetworkGuardPublisher,
        UserResolver,
        PublisherResolver,
        AdminGuard,
        PublisherGuard,
        GlobalSpinnerService,
        ContentOwnerGuard,
        RolePermissionService
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        LoginComponent,
        ForgotPasswordComponent,
        NewPasswordComponent,
        LogoutComponent,
        PageNotFoundComponent,
        ForbiddenComponent,
        GlobalSpinnerComponent,
        MaterialModule,
        TwoDigitDecimaNumberDirective,
        FourDigitDecimaNumberDirective,
        HasNetworkPermissionDirective,
        CommifiedNumberInputDirective,
        HasSalesRepPermissionDirective,
        HasUserRolePermissionDirective,
        HasPermissionDirective,
        TargetingHideForDirective,
        HasNoPermissionDirective,
        DoubleClickToEnableDirective,
        ScrollToSectionDirective
    ]
})
export class CoreModule {
}
